var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M34.5 27a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M18 39l5.25-14.25h3L31.5 39h-3l-1.105-3h-5.29L21 39zm8.29-6-1.54-4.179L23.21 33zM33 39V28.5h3V39z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#FF9807",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.212 18h-1.758l1.98-6h2.227l1.98 6h-1.757l-1.313-4.348h-.047zm-.328-2.367h3.304v1.219h-3.304zM19.848 12v6H18.22v-6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgAi;